export const environment = {
  envName: "test",
  production: true,
  dashboardV1Url: "https://v1.testsrv.comunicare.io",
  maintenanceUrl: "",
  featuresToDisable: [],
  tpdaBaseUrl: "https://test.pda.comunicare.site/",
};
